import React, {useState,useEffect } from "react";
import { isUserExists } from "../../features/userSlice";
import { useDispatch, useSelector } from 'react-redux';
import {useNavigate } from "react-router-dom";
import { msgAccessPromt } from "../../constant/constant";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Login = () => {
    const [phone, setPhone] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isUserLogedIn } = useSelector((state) => state.users);

    const generateToken = () => {
        return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      };

      
    const handleSubmit = async(e) => {
       
        msgAccessPromt({dispatch,msg:'LOADING',error:true});
        if(phone.length!==10){
            msgAccessPromt({dispatch,error:true,msg:'Enter Valid mobile number !!'});
            return false;
        }
          
        e.preventDefault();
        let dataSet = new FormData();
        let token = generateToken();
        
        dataSet.append('phone_number',phone);
        dataSet.append('token_id', token);
        localStorage.setItem("phone_number", phone);
        localStorage.setItem("user_token", token);

        try {
            const data = await dispatch(isUserExists(dataSet)).unwrap(); // Unwrap to get the resolved value
            if(data.success){
                msgAccessPromt({dispatch,error:false,msg:'You are Already Signed Up Enter Mpin for Login !!'});
                navigate("/login_mpin");
            }else{
              //  msgAccessPromt({dispatch,error:false,msg:'Enter Otp for Signup !!'});
              msgAccessPromt({dispatch,msg:'LOADING',error:false});
                navigate("/sign-up");

            }
        } catch (error) {
            console.error('API Error:', error);
            msgAccessPromt({dispatch,error:true,msg:'Api Error'});

        }
        
    };

    const handleChange = (e) => {
        const value = e.target.value;
        // Allow only digits and restrict to 10 characters
        if (/^\d*$/.test(value) && value.length <= 10) {
            setPhone(value);
        }else{
            msgAccessPromt({dispatch,error:true,msg:'Allow only 10 digits valid numbers.'});
        }
    };
   
    useEffect(()=>{
        if(isUserLogedIn){
            navigate("/home");
        }
    },[isUserLogedIn]);


    return (
        <div className='bodyDiv' style={{marginTop:'10%'}} >
            {/* <div style={{position:'absolute',top:'14%'}}>
            <img src="home/images/logo_tara.png" style={{maxWidth:'56%'}} />
            </div> */}
        <div className="signup-container">
            <div className="title_Form">
              <div className="title_left">
                 <h1 className="main_title">ENTER NUMBER</h1>
                  <p>Enter your valid mobile number</p>
                  </div>
                  <div className="title_right">
                     <FontAwesomeIcon icon={faMobileScreen} color="#007bff" size="3x" padding='3%' />
                     
                  </div>
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faMobileScreen} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="number" value={phone} onChange={handleChange} placeholder="Enter mobile number" />
            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <button onClick={handleSubmit} className="continue-button">NEXT</button>
            <button onClick={handleSubmit} className="continue-button">REGISTER</button>
        </div>
        </div>
    );
};

export default Login;
const styles = `
    .bodyDiv {
        font-family: Arial, sans-serif;
        background-color: #f9f9f9;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    

    .signup-container {
       
        width: 100%;
        text-align: center;
        padding: 6%;
    }

    .signup-container h1 {
        font-size: 24px;
        color: #007bff;
        margin-bottom: 5px;
    }

    .signup-container p {
        font-size: 14px;
        color: #6c757d;
        margin-bottom: 25px;
    }

    .input-group {
        position: relative;
        margin-bottom: 20px;
        text-align: left;
    }

    

    .input-group input:focus {
        border-color: #007bff;
    }

    .input-group i {
        position: absolute;
        left: 87%;
        top: 50%;
        transform: translateY(-50%);
        color: #aaa;
        font-size: 18px;
    }

    .continue-button {
        width: 100%;
        padding: 12px;
        font-size: 16px;
        color: #fff;
        background-color: #007bff;
        border: none;
        border-radius: 25px;
        cursor: pointer;
        margin-bottom: 15px;
        box-shadow: 0 4px 6px rgba(230, 57, 70, 0.3);
    }

    .continue-button:hover {
        background-color: #007bff;
    }

    .signin-link {
        font-size: 14px;
        color: #6c757d;
    }

    .signin-link a {
        color: #007bff;
        text-decoration: none;
    }

    .signin-link a:hover {
        text-decoration: underline;
    }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);